import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import RevertIcon from "@mui/icons-material/ReplayRounded";
import { IconButton, Tooltip } from "@mui/material";
import { stringifyValue } from "@entrilia/shared/utilities/stringHelper";
import VisibleIcon from "@entrilia/shared/icons/VisibleIcon";
import { useDataImportChangesListActionsContext } from "./DataImportChangesListActionsContext";
import type { DataImportChangeRowModel } from "./dataImportChangesGridTypes";

interface Props {
  row: DataImportChangeRowModel;
  isGridEditable: boolean;
  fileContainerId?: string;
  previewFileFieldKey?: string;
}

const PreviewAction = ({ row, fileContainerId, previewFileFieldKey }: Omit<Props, "isGridEditable">) => {
  const { onPreviewFileContainerFile } = useDataImportChangesListActionsContext();

  if (!fileContainerId || !previewFileFieldKey) {
    return null;
  }

  const previewFileFieldValue = row.fieldValueChanges.find((change) => change.key === previewFileFieldKey)?.newValue;
  const fileName = previewFileFieldValue ? stringifyValue(previewFileFieldValue) : "";

  return (
    <Tooltip title="Preview file from File Container">
      <span>
        <IconButton onClick={() => onPreviewFileContainerFile(fileContainerId, fileName)} disabled={!fileName}>
          <VisibleIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
};

const RevertExcludedAction = ({ row }: { row: DataImportChangeRowModel }) => {
  const { onRevertExcludedChange } = useDataImportChangesListActionsContext();

  return (
    <Tooltip title="Revert excluded record">
      <span>
        <IconButton disabled={!row.action || row.action === "DoNothing"} onClick={() => onRevertExcludedChange(row.id)}>
          <RevertIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
};

const ExcludeAction = ({ row }: { row: DataImportChangeRowModel }) => {
  const { onExcludeChange } = useDataImportChangesListActionsContext();

  return (
    <Tooltip title="Exclude record">
      <span>
        <IconButton color="error" disabled={row.action === "DoNothing"} onClick={() => onExcludeChange(row.id)}>
          <DeleteIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
};

const DataImportChangesListViewActionsCell = ({ row, isGridEditable, fileContainerId, previewFileFieldKey }: Props) => {
  return (
    <>
      <PreviewAction row={row} fileContainerId={fileContainerId} previewFileFieldKey={previewFileFieldKey} />
      {isGridEditable && row.isExcluded && <RevertExcludedAction row={row} />}
      {isGridEditable && !row.isExcluded && <ExcludeAction row={row} />}
    </>
  );
};

export default DataImportChangesListViewActionsCell;
